import React from 'react'
import SeminarModeContainer from './SeminarModeContainer'

const SeminarMode = (props) => (
  <SeminarModeContainer {...props} />
)

export default SeminarMode



// WEBPACK FOOTER //
// ./src/routes/SeminarMode/index.js